import React from 'react';
import Sidebar from './Sidebar';
import { Container, Row, Col } from 'react-bootstrap';

const DashboardLayout = ({ children }) => {
    return (
        <Container fluid className='bg-transparent'>
            <Row className="min-vh-100">
                <Col md={2} className="">
                    <Sidebar />
                </Col>
                <Col md={10} className="">
                    {children}
                </Col>
            </Row>
        </Container>
    );
};

export default DashboardLayout;
